import { Currency, Pagination, TransactionWarning } from '@ui/src';

export interface PaymentOrder {
  acceptedByEmployee?: string;
  acceptedByEmployeeId?: string;
  createdAt: string;
  currency: Currency;
  currencyId: string;
  deletedAt?: string;
  url?: string;
  id: string;
  orderAcceptedAt?: string;
  orderCreatedAt: string;
  orderCreated?: string;
  orderRejectedAt?: string;
  orderSignedAt: string;
  organizationId: string;
  pspPartner: any;
  pspPartnerAccount: any;
  pspPartnerAccountId?: string;
  pspPartnerId?: string;
  orderNumber?: string;
  orderUploadId?: string;
  receiptUploadId?: string;
  recepientAccount: {
    accountType: string;
    active: boolean;
    categoryId: string;
    clientName: string;
    closed: boolean;
    closedAt?: string;
    createdAt: string;
    creditBlock: boolean;
    debitBlock: boolean;
    deletedAt?: string;
    description: string;
    fullNumber: string;
    groupId: string;
    iban: string;
    id: string;
    number: string;
    organizationId: string;
  };
  recepientAccountId: string;
  rejectedByEmployee?: any;
  rejectedByEmployeeId?: string;
  signedByOrganizationId: string;
  status: string;
  sum: number;
  type: string;
  updatedAt: string;
  uploadId: string;
  confirmedAmount: number;
  pendingAmount: number;
  rejectedAmount: number;
  acceptedTransactions?: number;
  allTransactions?: number;
  procTransactions?: number;
  rejectedTransactions?: number;
  uploadedByEmployee?: {
    profile?: {
      firstName: string;
      lastName: string;
    };
  };
  uploadedByEmployeeId?: string;
  beneficiariesCount: {
    accepted: number;
    all: number;
    proc: number;
    rejected: number;
  };
  anonymizedAt?: string;
  render: Record<string, any>;
}

export interface PaymentOrderStatus {
  allowed: boolean;
  statusNext: string;
  errors?: string[];
  warnings?: string[];
}

export interface PaymentOrderStatuses {
  next: PaymentOrderStatus[];
  prev: PaymentOrderStatus[];
}

export interface PaymentOrderFormValues {
  orderCreatedAt?: string;
  sum?: string | number;
  currencyId?: string;
  recepientAccountId?: string;
  pspPartnerId?: string;
  pspPartnerAccountId?: string;
  orderNumber?: string;
  receiptUploadId?: string;
  orderUploadId?: string;
  organizationId?: string;
  type?: string;
}

export enum StatusTitle {
  DRAFT = 'Draft',
  NONE = 'None',
  NEW = 'New',
  PROC = 'Proc',
  SENT = 'Sent',
  ARCH = 'ARCH',
  REV = 'Rev',
  AML = 'AML',
  AML_INFO = 'AML Info',
  AML_REJ = 'AML Rejected',
  AML_DONE = 'AML Done',
  REJECTED = 'Rejected',
  NOT_SIGNED = 'Not Signed',
  READY_TO_SEND = 'Ready to Send',
  READY_TO_PSP = 'Ready to PSP',
  ACCP_OUT = 'ACCP Out',
  UNDEFINED_FUNDS = 'Undefined Funds',
  ACCEPTED = 'Accepted',
  QUEUED = 'Pending Review',
}

export interface Order {
  id: string;
  orderId: string;
  acceptedIn?: string;
  beneficiaryCity: string;
  amount?: string;
  paymentType?: string;
  url?: string;
  beneficiaryName: string;
  documentNumber?: string;
  createdAt: string;
  paymentDetails?: string;
  beneficiaryAccount?: string;
  originatorAccountNumber?: string;
  originatorFullName?: string;
  originatorCountry?: string;
  originatorCity?: string;
  originatorAddress?: string;
  originatorsBankBic?: string;
  originatorsBankSortCode?: string;
  originatorsBankName?: string;
  originatorsAddress?: string;
  originatorsIntermediaryBankBic?: string;
  originatorsIntermediaryBankCorrespondentAccount?: string;
  originatorsIntermediaryBankName?: string;
  originatorsIntermediaryBankCountry?: string;
  originatorsIntermediaryBankAddress?: string;
  originatorsCountry?: string;
  currency?: string;
  destAmount: number;
  destCurrencyId: string;
  destCurrency: Currency;
  destCountryId: string;
  transferDate?: string;
  postingDate?: string;
  destCountry: {
    name: string;
    id: string;
  };
  paymentOrder?: {
    status: StatusTitle;
    orderAcceptedAt?: string;
    orderCreatedAt?: string;
    recepientAccount: {
      accountType: string;
      active: boolean;
      categoryId: string;
      clientName: string;
      closed: boolean;
      closedAt?: string;
      createdAt: string;
      creditBlock: boolean;
      debitBlock: boolean;
      deletedAt?: string;
      description: string;
      fullNumber: string;
      groupId: string;
      iban: string;
      id: string;
      number: string;
      organizationId: string;
      organization: {
        id: string;
        firstName?: string;
        lastName?: string;
        companyName?: string;
      };
    };
    recepientAccountId: string;
  };
  recepientAccountId?: string;
  orderAcceptedAt?: string;
  orderCreatedAt?: string;
  localAmount: number;
  localCurrencyId: string;
  localCurrency: Currency;
  localCountryId: string;
  localCountry: {
    id: string;
    name: string;
  };
  senderDob: string;
  senderAddress: string;
  senderName: string;
  senderId: string;
  orderDate: string;
  paymentOrderId?: string;
  render: Record<string, any>;
}

export interface WarningGroup {
  createdAt: string;
  id: string;
  organizationId: string;
  updatedAt: string;
  blocklistNumber?: string;
  type?: string;
  warnings: {
    edges: { node: TransactionWarning }[];
    pageInfo: Pagination;
  };
  warningsGroupsBlacklists: {
    edges: {
      node: {
        blacklist: {
          name: string;
        };
        blacklistId: string;
        createdAt: string;
        deletedAt: string;
        id: string;
        updatedAt: string;
        warningGroupId: string;
        warningsCount: string;
      };
    }[];
    pageInfo: Pagination;
  };
}
